import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { RecipientsApi, RequestStrategyEnum, type WithSignal, type GetRecipientMandatoryFieldsRequest } from '@shared/api';

const getMandatoryFieldsEffect = createEffect(({ signal, ...request }: WithSignal<GetRecipientMandatoryFieldsRequest>) =>
  RecipientsApi.getMandatoryFields(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<string[]>([])
  .on(getMandatoryFieldsEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getMandatoryFieldsEffect.pending, (_, data) => data)
  .on(getMandatoryFieldsEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getMandatoryFieldsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getMandatoryFieldsEffect, () => null)
  // .on(getMandatoryFieldsEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getMandatoryFieldsEffect.fail, (_, data) =>
    ApiUtils.abortApiErrorFailCaseTrigger(data.error, 'Something went wrong while fetching Mandatory Fields. Please try again.'),
  )
  .on(getMandatoryFieldsEffect.done, () => undefined)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

const getMandatoryFieldsApi = ApiUtils.wrapperApi(getMandatoryFieldsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getMandatoryFieldsApi.cancel());

export const $recipientMandatoryFieldsStore = {
  events: {
    getMandatoryFields: getMandatoryFieldsApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
